import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { IMpaNavigation } from 'feature-mpa-navigation'
import { MpaNavigationSymbol } from 'feature-mpa-navigation'
import type { IRouter, ICommonNavigationClickHandler } from './types'
import { Router } from './symbols'
import { getUrlHash } from './urlUtils'

const commonNavigationClickHandlerFactory = (
	router: IRouter,
	mpaNavigation?: IMpaNavigation
): ICommonNavigationClickHandler => {
	return {
		commonNavigationClickHandler: (anchor) => {
			const href = anchor.getAttribute('href')
			if (!href) {
				return false
			}
			if (anchor.getAttribute('target') === '_blank') {
				return false
			}
			if (!router.isInternalValidRoute(href)) {
				return false
			}

			const hashAnchor = getUrlHash(href)
			const dataAnchor = anchor.getAttribute('data-anchor')

			if (mpaNavigation?.isEligible({ anchorCompId: hashAnchor, anchorDataId: dataAnchor })) {
				return mpaNavigation.navigate(href)
			}

			router.navigate(href, { anchorDataId: dataAnchor || hashAnchor || 'SCROLL_TO_TOP' })
			return true
		},
	}
}

export const CommonNavigationClickHandler = withDependencies(
	[Router, optional(MpaNavigationSymbol)],
	commonNavigationClickHandlerFactory
)
